import React from "react";
import projects from "../data/projects";

const Projects = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 card m-5">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700 mb-7">
          Projects
        </h1>
        {projects.map((p) => (
          <div className="my-5 sm:text-lg" key={p.name}>
            <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
              <div className="flex justify-center items-center break-words">
                <div className="flex">
                  <span>
                    <i className="fa-solid fa-arrows-to-dot px-2"></i>
                  </span>
                  <span>
                    <a href={p.link} target="_blank" rel="noreferrer">
                      <label title={`Click here to explore ${p.name}`} className="cursor-pointer">
                        {p.name}
                      </label>
                    </a>
                  </span>
                  <span className="hidden sm:block">
                    <i className="fa-solid fa-arrows-to-dot px-2"></i>
                  </span>
                </div>
              </div>
            </span>
            <div className="">
              <div className="sm:flex space-x-2 px-1 py-1 mt-5">
                <div className="font-semibold sm:flex">
                  <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                  <span>Description:</span>
                </div>
                <p className="">{p.description}</p>
              </div>
              <div className="sm:flex space-x-2 px-1 py-1">
                <div className="font-semibold sm:flex">
                  <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                  <span>Technology Used:</span>
                </div>
                <div className="">{p.tech}</div>
              </div>
              <div className="sm:flex space-x-2 px-1 py-1">
                <div className="font-semibold">
                  <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                  link:
                </div>
                <div>
                  <a className="text-blue-600 underline font-semibold hover:text-primary-600 dark:hover:text-primary-400" href={p.link} target="_blank" rel="noreferrer">
                    <label title={`Click here to explore ${p.name}`}>{p.link}</label>
                  </a>
                </div>
              </div>
              <div className="sm:flex space-x-2 px-1 mb-5 py-1">
                <div className="font-semibold">
                  <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                  <span>Year of completion:</span>
                </div>
                <div className="">{p.year}</div>
              </div>
            </div>
          </div>
        ))}
        {/* <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://chat.thinkhat.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore Think Chat"
                      className="cursor-pointer"
                    >
                      Think Chat
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                Think Chat is a revolutionary AI-powered chat-bot, designed to
                understand and respond to your queries in any regional language
                . Developed by Think Hat Business Solutions, Think Chat is still
                in its beta phase and is constantly evolving through ongoing
                training.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">
                React Js in the frontend, Flask in the backend, MySql as
                database.
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://chat.thinkhat.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore Think Chat">
                    https://chat.thinkhat.in/
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                Associated with:
              </div>
              <div>
                <div className="">Think Hat Business Solutions</div>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Year of completion:</span>
              </div>
              <div className="">2024 - Present</div>
            </div>
          </div>
        </div> */}
        <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://sociocube.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore SocioCube"
                      className="cursor-pointer"
                    >
                      SocioCube - chatting and video calling website
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                SocioCube, a chatting and video calling platform where you can
                interact with anonymous persons. You can socialize yourself.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">
                React JS in the frontend, Node JS and Express JS in the backend,
                MongoDB as database and other helping technologies i.e.
                Socket.io.
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://sociocube.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore SocioCube">
                    https://sociocube.netlify.app/
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Year of completion:</span>
              </div>
              <div className="">2023</div>
            </div>
          </div>
        </div>
        <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://fileswift.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore Fileswift"
                      className="cursor-pointer"
                    >
                      FileSwift - Share and Transfer Files with Ease
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                FileSwift - Effortless File Sharing and Transfer Platform. Share
                Files Securely, transparently, conviniently with Custom Links.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">
                React JS in the frontend, Node JS and Express JS in the backend,
                MongoDB as database.
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://fileswift.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore FileSwift">
                    https://fileswift.netlify.app/
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Year of completion:</span>
              </div>
              <div className="">2023</div>
            </div>
          </div>
        </div>
        <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://snapnotebook.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore SnapNoteBook"
                      className="cursor-pointer"
                    >
                      SnapNoteBook - Your personal diary | Notebook
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                SnapNoteBook, your personal online diary and note storage
                solution. At SnapNoteBook, we understand the importance of
                keeping your thoughts, ideas, and to-dos organized in one secure
                and accessible place.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">
                React JS and Bootstrap in the frontend, Node JS and Express JS
                in the backend, MongoDB as database.
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://snapnotebook.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore SnapNoteBook">
                    https://snapnotebook.netlify.app/
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Year of
                completion:
              </div>
              <div className="">2023</div>
            </div>
          </div>
        </div>
        <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://manitext.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore ManiText"
                      className="cursor-pointer"
                    >
                      ManiText - Text utility platform
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                ManiText, your go-to destination for all your text manipulation
                needs. Whether you're a writer, student, or just someone looking
                to make your text work for you, we've got you covered. Our
                user-friendly online text manipulation tools are designed to
                simplify and enhance your text-related tasks.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">React JS and Bootstrap in the frontend.</div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://manitext.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore ManiText">
                    https://manitext.netlify.app/
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Year of
                completion:
              </div>
              <div className="">2023</div>
            </div>
          </div>
        </div>
        <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://remindee.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore Remindee"
                      className="cursor-pointer"
                    >
                      Remindee - To do list
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                Remindee, a to-do list is a simple but effective tool for
                managing tasks and staying organized. It's a list of things you
                need to do or want to do, typically organized in order of
                priority or due date.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">Bootstrap and JavaScript.</div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Live
                link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://remindee.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore Remindee">
                    https://remindee.netlify.app/
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Year of
                completion:
              </div>
              <div className="">2022</div>
            </div>
          </div>
        </div>
        <div className="my-5 text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>
                  <a
                    href="https://github.com/Subhadip4521/DailyMint"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <label
                      title="Click here to explore the source code of Daily Mint"
                      className="cursor-pointer"
                    >
                      Daily Mint - A news website
                    </label>
                  </a>
                </span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="sm:flex space-x-2 px-1 py-1 mt-5">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Description:</span>
              </div>
              <p className="">
                In a fast-paced world where information is currency and staying
                updated is a daily necessity, "Daily Mint" emerges as your go-to
                destination for news that's as crisp, insightful, and
                invigorating as a fresh sprig of mint. Welcome to a news website
                that prides itself on delivering a daily dose of information
                that not only informs but also leaves you with a sense of
                clarity and satisfaction.
              </p>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold sm:flex">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>
                <span>Technology Used:</span>
              </div>
              <div className="">Bootstrap, JavaScript and News API.</div>
            </div>
            <div className="sm:flex space-x-2 px-1 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>GitHub
                (source code) link:
              </div>
              <div>
                <a
                  className="text-blue-600 underline font-semibold hover:text-purple-800 dark:hover:text-purple-400 break-words"
                  href="https://github.com/Subhadip4521/DailyMint"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label title="Click here to explore source code of Daily Mint">
                    https://github.com/Subhadip4521/DailyMint
                  </label>
                </a>
              </div>
            </div>
            <div className="sm:flex space-x-2 px-1 mb-5 py-1">
              <div className="font-semibold">
                <i className="fa-solid fa-circle mr-2 text-xs mt-2"></i>Year of
                completion:
              </div>
              <div className="">2022</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
